var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.is_teacher)?_c('v-btn',{staticClass:"mt-4 mr-3",attrs:{"color":"primary","large":""},on:{"click":function($event){return _vm.click()}}},[_c('v-icon',{staticClass:"mr-4"},[_vm._v("mdi-plus")]),_vm._v(" Ajouter un cours ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }